import React, { useEffect, useRef, useState } from 'react'
import Container from '../../base/Container'
import Card from '../../controls/Card'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import * as opdCentersCrud from '../../../configurations/crud/opdCentersCrud'
import { useToast } from '../../controls/Toast/ToastService'
import { MdErrorOutline } from 'react-icons/md'
import { Link, useParams } from 'react-router-dom'
import { LIVE_URL, PAGE_SIZE } from '../../../configurations/initUrls'
import moment from 'moment'
import { getLoginInfo } from '../../../configurations/auth/getLoginInfo'
import { GetById } from '../../../configurations/crud/opdCentersCrud'
import { GetEDoctorStatusName } from '../../../configurations/enums/EDoctorStatus'
import { FaCircleInfo } from "react-icons/fa6";
import { IoMdAdd } from "react-icons/io";
import AddOpdOffline from './AddOpdOffline'
import { IoCheckmarkDoneCircleOutline } from 'react-icons/io5'
import ReceptionConfirmed from './ReceptionConfirmed'
import ReceptionEmergency from './ReceptionEmergency'
import ReceptionRegistered from './ReceptionRegistered'
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import WarningPopUp from './WarningPopUp'
import { VscDebugDisconnect } from 'react-icons/vsc'
import LoadingContainer from '../../controls/LoadingContainer'
import StatusContainer from '../../controls/StatusContainer'
import { ETypeBg, GetETypeName } from '../../../configurations/enums/EType'
import { allowSleep, keepAwake } from '../../../configurations/native/screenTime'
import { useKeepAwake } from 'react-keep-awake';
import useGlobalLoader from '../../../configurations/useGlobalLoader'
import { PiPlugsConnectedFill } from "react-icons/pi";
import DaillyShortReport from '../report/DaillyShortReport'

export default function Reception({ }) {
  const { start, end } = useGlobalLoader()
  const { centerid } = useParams()
  const toast = useToast()
  const [loding, setLoding] = useState(false)
  const [lodingCrud, setLodingCrud] = useState(false)
  const [isOpenAdd, setIsOpenAdd] = useState(false)
  const [isOpenPop, setIsOpenPop] = useState(false)
  const [isOpenUnavailable, setIsOpenUnavailable] = useState(false)
  const [isOpenAbsent, setIsOpenAbsent] = useState(false)
  const [currentSavedData, setCurrentSavedData] = useState()
  const [serachPatient, setSerachPatient] = useState("")
  const [isSerachPatient, setIsSerachPatient] = useState(0)

  const [eventMessage, setEventMessages] = useState("");

  const [centerData, setCenterData] = useState();
  const [doctorStatus, setDoctorStatus] = useState(1);

  const [currentData, setCurrentData] = useState();
  const [nextPatientData, setNextPatientData] = useState();

  const [viewUsers, setViewUsers] = useState(1);
  const [isPrint, setIsPrint] = useState(false);
  const [isDailyUpdate, setIsDailyUpdate] = useState(0)
  const loginInfo = getLoginInfo()

  const audioRef = useRef(null);
  const audioEmergencyRef = useRef(null);
  useKeepAwake()
  useEffect(() => {
    keepAwake()
    return () => {
      allowSleep()
    }
  }, [])


  const ringBell = () => {
    if (audioRef.current) {
      audioRef.current.play().catch((err) => {
        console.error("Playback failed:", err);
      });
    }
  };
  const ringBellEmergency = () => {
    if (audioEmergencyRef.current) {
      audioEmergencyRef.current.play().catch((err) => {
        console.error("Playback failed:", err);
      });
      toast.open(
        <div>
          <div className='font-bold'>Doctor's Call</div>
          <span>Please sent EMERGENCY numbers In.</span>
        </div>
        , <MdErrorOutline />, "danger", 10000);
    }
  };
  ///Chat Start Block\
  const [connection, setConnection] = useState();
  const [messages, setMessages] = useState([]);
  const [users, setUsers] = useState([]);
  const joinroom = async (user, room) => {
    try {
      const connection = new HubConnectionBuilder()
        .withUrl(LIVE_URL)
        .configureLogging(LogLevel.Information)
        .build();

      connection.on("UsersInRoom", (users) => {
        setUsers(users);
      });

      connection.on("ReceiveMessage", (user, message) => {
        console.log(message)
        switch (message) {
          case "1": { GetCenterDetails(); break; }
          case "2": { GetPatientWhoNext(); GetPatientInTheCabin(); setIsDailyUpdate(pre => pre + 1); break; }
          case "5": { ringBell(); break; }
          case "25": {
            ringBellEmergency(); break;
          }
        }
        setMessages(messages => [...messages, { user, message }]);
      });

      connection.onclose(e => {
        setConnection();
        setMessages([]);
        setUsers([]);
      })

      connection.onclose(e => {
        setConnection();
        setMessages([]);
      });

      await connection.start();
      await connection.invoke("JoinRoom", { user, room });
      setConnection(connection);

    } catch (e) {
      console.log(e);
    }
  }

  const sendMessage = async (message) => {
    try {
      await connection.invoke("SendMessage", message);
    } catch (e) {
      console.log(e);
    }
  }

  const closeConnection = async () => {
    try {
      await connection.stop();
    } catch (e) {
      console.log(e);
    }
  }

  ///Chat End Block
  const reConnect = () => {
    joinroom(loginInfo.userName + "_" + centerid + "_Reception", loginInfo.userName + "_" + centerid)
    toast.open("Connected", <VscDebugDisconnect />, "success")
  }
  useEffect(() => {
    joinroom(loginInfo.userName + "_" + centerid + "_Reception", loginInfo.userName + "_" + centerid)
    GetPatientInTheCabin()
    GetPatientWhoNext()
    GetCenterDetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const GetPatientInTheCabin = () => {
    setLoding(true)
    start()
    opdRegisteredCrud.GetPatientInTheCabin({
      DoctorId: loginInfo.doctorId,
      CenterId: centerid
    }).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentData(mdata.data)
      } else {
        setCurrentData()
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setCurrentData()
      setLoding(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const NextPatient = () => {
    setLoding(true)
    start()
    opdRegisteredCrud.NextPatient({
      CenterId: centerid
    }).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentData(mdata.data)
        GetPatientWhoNext()
        sendMessage("2")
        sendMessage("5")
        setIsOpenPop(false)
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
        setIsOpenPop(false)
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setLoding(false)
      end()
      setIsOpenPop(false)
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const SetToAbsent = () => {
    setLoding(true)
    start()
    opdRegisteredCrud.SetToAbsent({
      CenterId: centerid,
      Id: currentData.id
    }).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentData(mdata.data)
        GetPatientWhoNext()
        sendMessage("4")
        sendMessage("5")
        setIsOpenAbsent(false)
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
        setIsOpenAbsent(false)
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setLoding(false)
      end()
      setIsOpenAbsent(false)
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const PatientUnavailable = () => {
    setLoding(true)
    start()
    opdRegisteredCrud.PatientUnavailable({
      CenterId: centerid,
      Id: currentData.id
    }).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentData(mdata.data)
        GetPatientWhoNext()
        sendMessage("3")
        sendMessage("5")
        setIsOpenUnavailable(false)
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
        setIsOpenUnavailable(false)
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setLoding(false)
      end()
      setIsOpenUnavailable(false)
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const GetPatientWhoNext = () => {
    setLoding(true)
    start()
    try {
      opdRegisteredCrud.GetPatientWhoNext({
        DoctorId: loginInfo.doctorId,
        CenterId: centerid
      }).then(res => {
        let mdata = res.data
        if (mdata.result.succeeded) {
          setNextPatientData(mdata.data)
        } else {
          setNextPatientData()
        }
        setLoding(false)
        end()
      }).catch(errors => {
        setNextPatientData()
        setLoding(false)
        end()
        toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
      })
    }
    catch (error) {
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    }
  }

  const addOpdOffline = (param, setValues) => {
    setLodingCrud(true)
    start()
    opdRegisteredCrud.AddOfline(param).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentSavedData(mdata.data)
        setValues({
          opdCenterId: centerid,
          patientName: "",
          mobile: "",
          bloodGroup: "N/A",
          bloodPressure: "",
          weight: "",
          age: "",
          gender: 0,
          type: 0,
          note: "",
          cityId: "",
          stateId: "",
          patientAddress: ""
        })
        //setIsOpenAdd(false)

        //GetTodaysConfirmed()
        setIsPrint(true)
        toast.open("Opd added successfully.", <IoCheckmarkDoneCircleOutline />, "success")
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLodingCrud(false)
      end()
    }).catch(errors => {
      setLodingCrud(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const GetCenterDetails = () => {
    setLoding(true);
    start()
    GetById(centerid)
      .then((res) => {
        let mdata = res.data;
        if (mdata.result.succeeded) {
          setDoctorStatus(mdata.data.doctorStatus)
          setCenterData(mdata.data);
        } else {
          setCenterData();
        }
        setLoding(false);
        end()
      })
      .catch((errors) => {
        setCenterData();
        setLoding(false);
        end()
        toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
      });
  }

  const GetDoctorChangeStatus = (s) => {
    setLoding(true)
    start()
    opdCentersCrud.DoctorChangeStatus({
      Status: s,
      Id: centerid
    }).then(res => {
      let mdata = res.data
      if (mdata.succeeded) {
        setDoctorStatus(s)
        sendMessage("1")
        toast.open("Doctor is " + GetEDoctorStatusName(s), <FaCircleInfo />, "info")
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setLoding(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  // ---- config ----
  const DOCTOR_STATES = [
    { id: 1, label: "In The Cabin", color: "bg-green-500" },
    { id: 4, label: "On Rest", color: "bg-orange-500" },
    { id: 0, label: "Offline", color: "bg-red-500" },
  ]
  const TABS = [
    { id: 1, label: "Registered", color: "bg-blue-500" },
    { id: 2, label: "Confirmed", color: "bg-green-500" },
    { id: 3, label: "Emergency", color: "bg-red-500" },
  ]
  const searchScope = viewUsers == 1 ? "registered" : viewUsers == 2 ? "confirmed" : "emergency"

  // shared patient block (current + next)
  const PatientBody = ({ data }) => (
    <>
      <div className="text-2xl font-bold sm:text-3xl">{data.patientName}</div>
      <div className="mt-2 flex flex-wrap items-center justify-center gap-2">
        <span className="text-sm opacity-70">No.:</span>
        <span className="text-3xl font-bold sm:text-4xl">{data.confirmedAllotedNumber}</span>
        {data.confirmedAllotedNumber != data.opdNumberAlloted &&
          <span className="text-sm font-normal opacity-70">/{data.opdNumberAlloted}</span>}
        <StatusContainer bg={ETypeBg(data.type)} text={GetETypeName(data.type)} />
      </div>
      <div className="mt-2 text-sm opacity-70">Ref No. {data.id} {data.registeredIdForRef && "/" + data.registeredIdForRef}</div>
    </>
  )

  return (
    <Container>
      <div className="flex flex-col items-center">
        <audio ref={audioRef} src="/assets/audio/mixkit-cartoon-door-melodic-bell-110.wav" preload="auto" />
        <audio ref={audioEmergencyRef} src="/assets/audio/audiomass-output.wav" preload="auto" />
      </div>

      <div className="flex w-full flex-col px-2 sm:px-4">

        {/* ===== Header ===== */}
        <Card
          isBorder={true}
          isBack={true}
          title={
            <div className="flex w-full items-center gap-2">
              <button onClick={reConnect} title="Reconnect" className="grid h-8 w-8 place-items-center rounded-lg bg-emerald-50 text-emerald-600 transition hover:bg-emerald-100 active:scale-95">
                <PiPlugsConnectedFill />
              </button>
              <span>Reception</span>
            </div>
          }
        >
          {/* doctor status segmented control */}
          <div className="flex justify-center sm:justify-end md:-mt-12">
            <div className="flex max-w-full gap-1 overflow-x-auto rounded-xl bg-gray-100 p-1">
              {DOCTOR_STATES.map((s) => (
                <button
                  key={s.id}
                  type="button"
                  onClick={() => GetDoctorChangeStatus(s.id)}
                  className={`shrink-0 rounded-lg px-4 py-2 text-sm font-semibold transition ${doctorStatus == s.id ? `${s.color} text-white shadow` : "text-gray-500 hover:text-gray-700"}`}
                >
                  {s.label}
                </button>
              ))}
            </div>
          </div>

          {/* center info */}
          {centerData &&
            <div className="mt-4 flex flex-col items-center text-center text-gray-700">
              <div className="text-2xl font-bold text-gray-900">{centerData.centerName}</div>
              <div className="text-md text-gray-600">{centerData.address}</div>
              <div className="text-sm text-gray-500">
                {moment(centerData.opdStartTime).format("LT")} - {moment(centerData.opdEndTime).format("LT")}
              </div>
            </div>
          }

          {/* OPD flow controls */}
          {doctorStatus == 1 &&
            <div className="mt-4 flex flex-wrap justify-center gap-2 sm:justify-end">
              <button
                type="button"
                onClick={() => {
                  setIsOpenPop(!isOpenPop)
                  currentData
                    ? setEventMessages("Are you sure to call Next Patient?")
                    : setEventMessages("Are you sure to Start OPD?")
                }}
                className="rounded-xl bg-green-500 px-6 py-3 text-sm font-semibold text-white shadow transition hover:bg-green-400 focus:ring-2 focus:ring-green-500 active:scale-95"
              >
                {currentData ? "Next Patient" : "Start OPD"}
              </button>

              {currentData &&
                <>
                  <button
                    type="button"
                    onClick={() => {
                      setIsOpenUnavailable(!isOpenUnavailable)
                      setEventMessages("Are you sure to send current patient in the cabin to unavailable?")
                    }}
                    className="rounded-xl bg-orange-500 px-6 py-3 text-sm font-medium text-white shadow transition hover:bg-orange-400 focus:ring-2 focus:ring-orange-500 active:scale-95"
                  >
                    Unavailable
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setIsOpenAbsent(!isOpenAbsent)
                      setEventMessages("Are you sure to send current patient in the cabin to Absent?")
                    }}
                    className="rounded-xl bg-red-500 px-6 py-3 text-sm font-semibold text-white shadow transition hover:bg-red-400 focus:ring-2 focus:ring-red-500 active:scale-95"
                  >
                    Absent
                  </button>
                </>}
            </div>}
        </Card>
        <div className="my-2" />
        <DaillyShortReport refresh={isDailyUpdate} />
        <div className="my-2" />

        {/* ===== Main ===== */}
        <div className="flex flex-col gap-4 md:flex-row">

          {/* left: tabs + content */}
          <div className="md:w-9/12">
            <Card isBorder={true}>
              <div className="flex flex-col gap-2">
                {/* tabs + add */}
                <div className="flex items-center gap-2">
                  <div className="flex flex-1 gap-1 overflow-x-auto rounded-xl bg-gray-100 p-1">
                    {TABS.map((t) => (
                      <button
                        key={t.id}
                        type="button"
                        onClick={() => setViewUsers(t.id)}
                        className={`shrink-0 rounded-lg px-3 py-2 text-xs font-semibold transition sm:px-4 sm:text-sm ${viewUsers == t.id ? `${t.color} text-white shadow` : "text-gray-500 hover:text-gray-700"}`}
                      >
                        {t.label}
                      </button>
                    ))}
                  </div>
                  <button
                    type="button"
                    onClick={() => { setIsOpenAdd(!isOpenAdd); setIsPrint(false) }}
                    title="Add OPD"
                    className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-green-600 text-xl text-white shadow transition hover:bg-green-700 focus:ring-2 focus:ring-green-500 active:scale-95"
                  >
                    <IoMdAdd />
                  </button>
                </div>

                {/* search (now available on all sizes) */}
                <div className="flex items-center gap-2">
                  <input
                    type="text"
                    value={serachPatient}
                    onChange={(e) => setSerachPatient(e.target.value)}
                    placeholder={`Search ${searchScope} patient...`}
                    className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 outline-none focus:border-blue-500 focus:ring-blue-500"
                  />
                  <button
                    onClick={() => setIsSerachPatient(pre => pre + 1)}
                    className="grid h-10 w-10 shrink-0 place-items-center rounded-lg border border-brand-600 bg-brand-500 text-white transition hover:bg-brand-600 focus:outline-none focus:ring-4 focus:ring-brand-600/40"
                  >
                    <svg className="h-4 w-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                    </svg>
                    <span className="sr-only">Search</span>
                  </button>
                </div>
              </div>

              {/* tab content */}
              <div className="mt-3">
                {viewUsers == 1 && <ReceptionRegistered isActive={viewUsers == 1} searchTerm={serachPatient} isSearch={isSerachPatient} />}
                {viewUsers == 2 && <ReceptionConfirmed isActive={viewUsers == 2} searchTerm={serachPatient} isSearch={isSerachPatient} />}
                {viewUsers == 3 && <ReceptionEmergency isActive={viewUsers == 3} searchTerm={serachPatient} isSearch={isSerachPatient} />}
              </div>
            </Card>
          </div>

          {/* right: current + next */}
          <div className="flex flex-col gap-4 md:w-3/12">
            <Card isBorder={true} borderColor="border-green-500">
              {loding ? (
                <LoadingContainer text="Please wait..." />
              ) : (
                <div className="py-4 text-center text-gray-700">
                  {currentData ? (
                    <>
                      <div className="text-sm font-semibold uppercase tracking-wide text-gray-400">Current Patient</div>
                      <div className="mt-2"><PatientBody data={currentData} /></div>
                    </>
                  ) : (
                    <div className="py-8 text-xl font-semibold">Please Start OPD</div>
                  )}
                </div>
              )}
            </Card>

            {nextPatientData &&
              <Card isBorder={true} borderColor="border-brand-500">
                {loding ? (
                  <LoadingContainer text="Please wait..." />
                ) : (
                  <div className="py-4 text-center text-gray-700">
                    <div className="text-sm font-bold uppercase tracking-wide text-brand-500">Next Patient</div>
                    <div className="mt-2"><PatientBody data={nextPatientData} /></div>
                  </div>
                )}
              </Card>
            }
          </div>
        </div>
      </div>

      <AddOpdOffline addOpdOffline={addOpdOffline} currentSavedData={currentSavedData} isOpen={isOpenAdd} setIsOpen={setIsOpenAdd} loding={lodingCrud} isPrint={isPrint} setIsPrint={setIsPrint} />
      <WarningPopUp call={NextPatient} isOpen={isOpenPop} setIsOpen={setIsOpenPop} loding={lodingCrud} text={eventMessage} />
      <WarningPopUp call={PatientUnavailable} isOpen={isOpenUnavailable} setIsOpen={setIsOpenUnavailable} loding={lodingCrud} text={eventMessage} />
      <WarningPopUp call={SetToAbsent} isOpen={isOpenAbsent} setIsOpen={setIsOpenAbsent} loding={lodingCrud} text={eventMessage} />

    </Container>
  )
}